import { configureStore } from "@reduxjs/toolkit"
import commonDataReducer from '../slices/commonApiData'
import authorizationRouteReducer from '../slices/privateRouteAuthorizations'
import formationNavegation from '../slices/formationNavegation'
import routingSlice from '../slices/routing'

const store = configureStore({
  reducer: {
    commonData: commonDataReducer,
    enableRoute: authorizationRouteReducer,
    formationsNav: formationNavegation,
    routing: routingSlice
  },
});

export default store